import React, {useState} from "react";
import PropTypes from 'prop-types'
import Error from './eror'
import shortid from 'shortid'
const Formulario = ({guardarGasto, guardarCearGasto}) => {

    const [nombre, guardarNombre] = useState('');
    const [cantidad, guardarCantidad] = useState(0);
    const [error, guardarError] = useState(false);


    //cuando el usuario agrega un gasto
    const agregarGasto = e => {
        e.preventDefault();

        //validar
        if(cantidad < 1 || isNaN(cantidad) || nombre.trim() === '') {
            guardarError(true);
            return;
        }
        guardarError(false);

        //construir el gasto
        const gasto = {
            nombre,
            cantidad,
            id: shortid.generate()
        }
 
        //pasar el gasto al componente principal
        guardarGasto(gasto);
        guardarCearGasto(true); 

        //resetear el form
        guardarNombre('');
        guardarCantidad(0);
        
    }

    return (
        <form 
            onSubmit={agregarGasto}
        >
            <h2>Ingresa tu Gastos aqui:</h2>

            {/* validacion */}
            {error ? <Error mensaje='los campos son obligatorios'/> : null}

            <div className="campo">
                <label>Nombre Gasto</label>
                <input
                    type='text'
                    className="u-full-width"
                    placeholder="Ej. transporte"
                    value={nombre}
                    onChange={e => {guardarNombre(e.target.value)}}
                />
            </div>
            <div className="campo">
                <label>Cantidad Gasto</label>
                <input
                    type='number'
                    className="u-full-width"
                    placeholder="Ej. 300"
                    value={cantidad}
                    onChange={e => {guardarCantidad(parseInt(e.target.value, 10))}}
                />
            </div>
            <input
                type='submit'
                className="button-primary  u-full-width"
                value='Agregar Gasto'
            />
        </form>
    )
}

Formulario.propTypes = {
    guardarGasto: PropTypes.func.isRequired,
    guardarCearGasto: PropTypes.func.isRequired
}

export default Formulario;